import { useQuery } from '@tanstack/react-query';
import {
  type OnBehalfOfInput,
  type QueryAdditionalOptions,
  type UseQueryReturnType,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { feeKeys } from './keys';

const customerFeesInfo = graphql(/* GraphQL */ `
  query fees_stripeCustomerInfo($filter: OnBehalfOfInput) {
    fees_stripeCustomerInfo(filter: $filter) {
      customerId
      ephemeralKey
    }
  }
`);

const customerFeesInfoQuery = (filter: OnBehalfOfInput) => ({
  queryKey: feeKeys.customerInfo(filter),
  queryFn: () => gqlClient.request(customerFeesInfo, { filter }),
});

export function getCustomerFeesInfo(filter: OnBehalfOfInput) {
  return queryClient.fetchQuery(customerFeesInfoQuery(filter));
}

export function useCustomerFeesInfo(
  filter: OnBehalfOfInput,
  additionalOptions?: Omit<QueryAdditionalOptions, 'academicNamespaceId'>,
) {
  return useQuery({
    ...customerFeesInfoQuery(filter),
    ...additionalOptions,
    select: ({ fees_stripeCustomerInfo }) => fees_stripeCustomerInfo,
  });
}

export type ReturnTypeFromUseCustomerFeesInfo = UseQueryReturnType<
  typeof useCustomerFeesInfo
>;
